(function () {
  'use strict';
  if (window.__datenoStories) return;
  window.__datenoStories = true;

  var SEEN_KEY = 'stories_seen_v1';
  var IMAGE_MS = 5000;
  var VIDEO_FALLBACK_MS = 7000;
  var HOLD_MS = 250;
  var SWIPE_PX = 80;
  var MOVE_PX = 10;
  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  var overlay = null;
  var ui = {};
  var groups = [];
  var placement = 'home';
  var trigger = null;
  var gi = 0;
  var si = 0;
  var elapsed = 0;
  var duration = IMAGE_MS;
  var lastTs = null;
  var raf = 0;
  var loading = false;
  var held = false;
  var userPaused = false;
  var loadToken = 0;
  var errorRun = 0;
  var suppressClick = false;
  var holdTimer = 0;
  var pointer = null;
  var viewedKey = '';

  function el(tag, cls, attrs) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (attrs) Object.keys(attrs).forEach(function (k) { node.setAttribute(k, attrs[k]); });
    return node;
  }

  function track(name, extra) {
    if (typeof window.gtag !== 'function') return;
    var g = groups[gi];
    var slides = g ? g.slides : [];
    var params = {
      group_handle: g ? g.handle : '',
      group_name: g ? g.name : '',
      slide_index: si + 1,
      slide_count: slides.length,
      slide_heading: slides[si] ? slides[si].heading || '' : '',
      placement: placement,
      page_path: location.pathname
    };
    if (extra) Object.keys(extra).forEach(function (k) { params[k] = extra[k]; });
    window.gtag('event', name, params);
  }

  function readSeen() {
    try { return JSON.parse(localStorage.getItem(SEEN_KEY)) || []; } catch (e) { return []; }
  }

  function markSeen(handle) {
    var seen = readSeen();
    if (seen.indexOf(handle) === -1) seen.push(handle);
    try { localStorage.setItem(SEEN_KEY, JSON.stringify(seen)); } catch (e) { return; }
    document.querySelectorAll('.stories__bubble').forEach(function (b) {
      if (b.__group && b.__group.handle === handle) b.classList.add('is-seen');
    });
  }

  function build() {
    overlay = el('div', 'stories-overlay', { role: 'dialog', 'aria-modal': 'true', 'aria-label': 'ストーリー', hidden: '' });
    var stage = el('div', 'stories-overlay__stage');
    ui.bg = el('div', 'stories-overlay__bg');
    ui.img = el('img', 'stories-overlay__img', { alt: '' });
    ui.video = el('video', 'stories-overlay__video', { muted: '', playsinline: '' });
    ui.video.muted = true;
    ui.video.playsInline = true;
    ui.video.hidden = true;

    var top = el('div', 'stories-overlay__top');
    ui.bars = el('div', 'stories-overlay__bars');
    var head = el('div', 'stories-overlay__head');
    ui.avatar = el('img', 'stories-overlay__avatar', { alt: '' });
    ui.name = el('span', 'stories-overlay__name');
    ui.pause = el('button', 'stories-overlay__btn', { type: 'button', 'aria-label': '一時停止', 'aria-pressed': 'false' });
    ui.pause.textContent = '⏸';
    ui.close = el('button', 'stories-overlay__btn', { type: 'button', 'aria-label': '閉じる' });
    ui.close.textContent = '×';
    head.append(ui.avatar, ui.name, ui.pause, ui.close);
    top.append(ui.bars, head);

    ui.prev = el('button', 'stories-overlay__zone stories-overlay__zone--prev', { type: 'button', 'aria-label': '前へ' });
    ui.next = el('button', 'stories-overlay__zone stories-overlay__zone--next', { type: 'button', 'aria-label': '次へ' });

    var bottom = el('div', 'stories-overlay__bottom');
    ui.title = el('p', 'stories-overlay__title');
    ui.cta = el('a', 'stories-overlay__cta');
    bottom.append(ui.title, ui.cta);

    ui.live = el('div', 'stories-overlay__live', { 'aria-live': 'polite' });

    stage.append(ui.bg, ui.img, ui.video, ui.prev, ui.next, top, bottom, ui.live);
    overlay.append(stage);
    document.body.appendChild(overlay);

    ui.close.addEventListener('click', close);
    ui.pause.addEventListener('click', function () { setUserPaused(!userPaused); });
    ui.prev.addEventListener('click', function () { if (!consumeSuppress()) prev(); });
    ui.next.addEventListener('click', function () { if (!consumeSuppress()) next(); });
    ui.cta.addEventListener('click', function () {
      track('story_button_click', { link_url: ui.cta.getAttribute('href') || '', transport_type: 'beacon' });
    });
    ui.img.addEventListener('error', onMediaError);
    ui.video.addEventListener('error', onMediaError);
    overlay.addEventListener('keydown', onKey);
    overlay.addEventListener('pointerdown', onPointerDown);
    overlay.addEventListener('pointermove', onPointerMove);
    overlay.addEventListener('pointerup', onPointerEnd);
    overlay.addEventListener('pointercancel', onPointerEnd);
  }

  function consumeSuppress() {
    if (!suppressClick) return false;
    suppressClick = false;
    return true;
  }

  function onPointerDown(e) {
    if (e.target.closest('.stories-overlay__btn, .stories-overlay__cta')) return;
    pointer = { x: e.clientX, y: e.clientY, moved: false };
    suppressClick = false;
    holdTimer = window.setTimeout(function () {
      held = true;
      suppressClick = true;
      applyPause();
    }, HOLD_MS);
  }

  function onPointerMove(e) {
    if (!pointer) return;
    var dx = e.clientX - pointer.x;
    var dy = e.clientY - pointer.y;
    if (Math.abs(dx) > MOVE_PX || Math.abs(dy) > MOVE_PX) {
      pointer.moved = true;
      suppressClick = true;
    }
  }

  function onPointerEnd(e) {
    window.clearTimeout(holdTimer);
    var p = pointer;
    pointer = null;
    if (!p) return;
    if (held) {
      held = false;
      applyPause();
    }
    var dy = e.clientY - p.y;
    var dx = e.clientX - p.x;
    if (e.type === 'pointerup' && dy > SWIPE_PX && dy > Math.abs(dx)) close();
    window.setTimeout(function () { suppressClick = false; }, 50);
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'ArrowRight') { e.preventDefault(); next(); return; }
    if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); return; }
    if (e.key !== 'Tab') return;
    var items = Array.prototype.filter.call(
      overlay.querySelectorAll('button, a[href]'),
      function (n) { return !n.hidden && n.offsetParent !== null; }
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function setUserPaused(v) {
    userPaused = v;
    ui.pause.setAttribute('aria-pressed', v ? 'true' : 'false');
    ui.pause.setAttribute('aria-label', v ? '再生' : '一時停止');
    ui.pause.textContent = v ? '▶' : '⏸';
    applyPause();
  }

  function isPaused() { return userPaused || held || loading; }

  function applyPause() {
    var video = ui.video;
    if (!video.hidden) {
      if (isPaused()) video.pause();
      else { var played = video.play(); if (played && played.catch) played.catch(function () {}); }
    }
    lastTs = null;
  }

  function renderBars(count, active) {
    ui.bars.textContent = '';
    for (var i = 0; i < count; i++) {
      var bar = el('div', 'stories-overlay__bar');
      var fill = el('i');
      fill.style.transform = 'scaleX(' + (i < active ? 1 : 0) + ')';
      bar.appendChild(fill);
      ui.bars.appendChild(bar);
    }
  }

  function setProgress(ratio) {
    var fill = ui.bars.children[si] && ui.bars.children[si].firstChild;
    if (fill) fill.style.transform = 'scaleX(' + Math.min(Math.max(ratio, 0), 1) + ')';
  }

  function tick(ts) {
    raf = requestAnimationFrame(tick);
    if (isPaused()) { lastTs = null; return; }
    if (lastTs !== null) elapsed += ts - lastTs;
    lastTs = ts;
    setProgress(elapsed / duration);
    if (elapsed >= duration) next();
  }

  function startTimer() {
    cancelAnimationFrame(raf);
    lastTs = null;
    raf = requestAnimationFrame(tick);
  }

  function stopTimer() { cancelAnimationFrame(raf); }

  function mediaReady(ms) {
    loading = false;
    errorRun = 0;
    duration = ms;
    elapsed = 0;
    applyPause();
  }

  function onMediaError() {
    if (!overlay || overlay.hidden) return;
    console.warn('[stories] media failed to load', groups[gi] && groups[gi].slides[si]);
    errorRun += 1;
    if (errorRun >= groups[gi].slides.length) { close(); return; }
    next();
  }

  function show(g, s) {
    gi = g;
    si = s;
    var group = groups[gi];
    var slide = group.slides[si];
    var token = ++loadToken;
    loading = true;
    elapsed = 0;
    ui.avatar.src = group.icon;
    ui.name.textContent = group.name;
    renderBars(group.slides.length, si);
    ui.title.textContent = slide.heading || '';
    ui.live.textContent = (slide.heading || group.name) + '（' + (si + 1) + '/' + group.slides.length + '）';
    if (slide.url) {
      ui.cta.hidden = false;
      ui.cta.setAttribute('href', slide.url);
      ui.cta.textContent = slide.button || '詳しく見る';
    } else {
      ui.cta.hidden = true;
      ui.cta.removeAttribute('href');
    }
    var key = group.handle + ':' + si;
    if (key !== viewedKey) { viewedKey = key; track('story_slide_view'); }

    if (slide.video) {
      ui.img.hidden = true;
      ui.video.hidden = false;
      ui.bg.style.backgroundImage = 'none';
      ui.video.onloadedmetadata = function () {
        if (token !== loadToken) return;
        var d = ui.video.duration;
        mediaReady(isFinite(d) && d > 0 ? d * 1000 : VIDEO_FALLBACK_MS);
      };
      ui.video.src = slide.video;
      ui.video.load();
    } else {
      ui.video.pause();
      ui.video.hidden = true;
      ui.video.removeAttribute('src');
      ui.img.hidden = false;
      ui.bg.style.backgroundImage = 'url("' + slide.image.replace(/"/g, '%22') + '")';
      ui.img.onload = function () { if (token === loadToken) mediaReady(IMAGE_MS); };
      ui.img.src = slide.image;
      if (ui.img.complete && ui.img.naturalWidth > 0) mediaReady(IMAGE_MS);
    }

    var following = group.slides[si + 1];
    if (following && following.image) new Image().src = following.image;
    startTimer();
  }

  function next() {
    var group = groups[gi];
    if (si < group.slides.length - 1) { show(gi, si + 1); return; }
    track('story_complete');
    markSeen(group.handle);
    if (gi < groups.length - 1) show(gi + 1, 0);
    else close();
  }

  function prev() {
    if (si > 0) show(gi, si - 1);
    else if (gi > 0) show(gi - 1, groups[gi - 1].slides.length - 1);
    else show(gi, 0);
  }

  function open(root, index, bubble) {
    if (!overlay) build();
    groups = root.__storiesData;
    placement = root.dataset.placement || 'home';
    trigger = bubble;
    errorRun = 0;
    viewedKey = '';
    userPaused = reduceMotion;
    setUserPaused(reduceMotion);
    overlay.classList.remove('is-closing');
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    gi = index;
    si = 0;
    track('story_open');
    show(index, 0);
    ui.close.focus();
  }

  function close() {
    if (!overlay || overlay.hidden) return;
    stopTimer();
    loadToken += 1;
    ui.video.pause();
    var finish = function () {
      overlay.hidden = true;
      overlay.classList.remove('is-closing');
      ui.img.removeAttribute('src');
      ui.video.removeAttribute('src');
      document.documentElement.style.overflow = '';
      if (trigger) trigger.focus();
    };
    if (reduceMotion) { finish(); return; }
    overlay.classList.add('is-closing');
    window.setTimeout(finish, 230);
  }

  function setupArrows(root) {
    var rail = root.querySelector('.stories__rail');
    if (!rail || !window.matchMedia) return;
    var mq = window.matchMedia('(hover: hover) and (pointer: fine)');
    var prevBtn = el('button', 'stories__arrow stories__arrow--prev', { type: 'button', 'aria-label': '前へ', hidden: '' });
    var nextBtn = el('button', 'stories__arrow stories__arrow--next', { type: 'button', 'aria-label': '次へ', hidden: '' });
    prevBtn.textContent = '‹';
    nextBtn.textContent = '›';
    var fadeL = el('div', 'stories__fade stories__fade--prev', { 'aria-hidden': 'true', hidden: '' });
    var fadeR = el('div', 'stories__fade stories__fade--next', { 'aria-hidden': 'true', hidden: '' });
    root.append(fadeL, fadeR, prevBtn, nextBtn);

    function setShown(node, on) {
      node.hidden = !on;
    }

    function update() {
      var over = mq.matches && rail.scrollWidth - rail.clientWidth > 1;
      root.classList.toggle('has-arrows', over);
      var canPrev = over && rail.scrollLeft > 1;
      var canNext = over && rail.scrollLeft + rail.clientWidth < rail.scrollWidth - 1;
      var active = document.activeElement;
      setShown(prevBtn, canPrev);
      setShown(fadeL, canPrev);
      setShown(nextBtn, canNext);
      setShown(fadeR, canNext);
      if (active === prevBtn && !canPrev && canNext) nextBtn.focus();
      else if (active === nextBtn && !canNext && canPrev) prevBtn.focus();
    }

    function go(dir) {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'story_rail_arrow', {
          direction: dir > 0 ? 'next' : 'prev',
          placement: root.dataset.placement || 'home',
          page_path: location.pathname
        });
      }
      rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (mq.addEventListener) mq.addEventListener('change', update);
    update();
  }

  function init(root) {
    var script = root.querySelector('script[data-stories-json]');
    if (!script) return;
    var data;
    try { data = JSON.parse(script.textContent); } catch (e) { console.warn('[stories] invalid json'); return; }
    root.__storiesData = data.filter(function (g) { return g.slides && g.slides.length; });
    var seen = readSeen();
    root.querySelectorAll('.stories__bubble').forEach(function (b) {
      var g = data[Number(b.dataset.index)];
      b.__group = g;
      if (g && seen.indexOf(g.handle) !== -1) b.classList.add('is-seen');
      b.addEventListener('click', function () {
        var idx = root.__storiesData.indexOf(g);
        if (idx >= 0) open(root, idx, b);
      });
    });
    setupArrows(root);
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'stories_view', {
            group_count: root.__storiesData.length,
            placement: root.dataset.placement || 'home',
            page_path: location.pathname
          });
        }
      }, { threshold: 0.5 });
      io.observe(root);
    }
  }

  function boot() { document.querySelectorAll('[data-stories]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
